import { render, staticRenderFns } from "./ticket.vue?vue&type=template&id=2dc618bc&scoped=true"
import script from "./ticket.vue?vue&type=script&lang=js"
export * from "./ticket.vue?vue&type=script&lang=js"
import style0 from "./ticket.vue?vue&type=style&index=0&id=2dc618bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc618bc",
  null
  
)

export default component.exports